<template>
  <div class="score-info" id="score-info">
    <p>
      Score:
      <span class="highlighted-text">{{ score }}</span>
    </p>
    <p>
      Best:
      <span class="highlighted-text score-clickable" @click="openShareModal()">
        {{ baseScore }} (+{{ bonusPoints }}
        <i class="fas fa-users"></i>)
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: ["score", "baseScore", "bonusPoints", "currentUser"],
  methods: {
    openShareModal() {
      this.$modal.show("share-modal", {
        currentUser: this.currentUser,
        totalScore: this.totalScore
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.score-clickable {
  cursor: pointer;
}

.score-info {
  text-transform: uppercase;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
}

.score-info.score-info-mobile {
  display: block;
}

.fa-users {
  margin-bottom: 3px;
  margin-left: 3px;
}

@media (max-width: 768px) {
  .score-info {
    display: block;
    padding: 0 23px;
  }
}

@media (max-width: 350px) {
  .score-info {
    display: block;
    padding: 0 23px;
  }
}
</style>